import Component from '../component';

export default class AdvancedSlider extends Component {
    constructor(...args) {
        super(...args);

        this.params = {
            current: 0,
            next: 0,
            canClick: true
        }
    }
    init(){
        super.init();

        this.dom.slideImage = this.dom.component.querySelector(".slide-image");
        this.dom.bgImg = this.dom.slideImage.querySelectorAll(".bg-img");
        this.dom.legend = this.dom.component.querySelectorAll(".legend");
        this.dom.slideText = this.dom.component.querySelector(".slide-text");
        this.dom.prev = this.dom.component.querySelector(".content-prev.nav");
        this.dom.next = this.dom.component.querySelector(".content-next.nav");
        this.dom.bullet = this.dom.component.querySelectorAll(".bullet");

        this.params.total = this.dom.bgImg.length - 1;

        // Set text blocs height from max height
        this._setSlideTextHeight(this._getSlideTextMaxHeight());
    }
    bind() {
        super.bind();

        if (this.dom.bgImg.length > 1){
            this.dom.prev.addEventListener("click", this._process.bind(this, "prev"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }

    }

    _process(direction){
        if ( this.params.canClick == false)
            return;
        
        this.params.canClick = false;

        this.params.canClick = false;
        if ( direction == "next" && this.params.current < this.params.total){
            this.params.next++;
        }
        else if (direction == "next" && this.params.current == this.params.total) {
            this.params.next = 0;
        }
        else if (direction == "prev" && this.params.current > 0) {
            this.params.next--;
        }
        else if (direction == "prev" && this.params.current == 0) {
            this.params.next = this.params.total;
        }

        this.animLegend = new TimelineMax({
            onComplete: () => {
                this.params.current = this.params.next;
                // this.params.canClick = true;
            }
            // end
        });

        this._animate();


    }

    /**
     * Set height for all slide text blocs
     * @param {Number} height Input height for text blocs
     * @private
     */
    _setSlideTextHeight(height) {
        this.dom.slideText.style.minHeight = height + 'px';
    }

    /**
     * Get max height for slide text blocs
     * @return {Number} max height
     * @private
     */
    _getSlideTextMaxHeight() {
        var heights = Array.from(this.dom.legend).map((el) => el.offsetHeight);
        //console.log(heights);
        return Math.max.apply(null, heights);
    }

    /*
    init(top: 25%;) {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/advanced-slider/advanced-slider.js